import { DomHelper } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { getAppCardNode } from "./appCardDefault";
import { Util } from "./util";
import { DEBUG, DEFAULT_PREFS } from "./config";
let store;
export function appUserInvitation(globalStore, username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appUserInvitation");
    const additionalClassList = ['full-width-interaction'];
    store = globalStore;
    const idString = 'rudi-voucher';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, false, [], null, (event) => {
        if (DEBUG)
            console.log("appUserInvitation");
        let injectNode = cardNode.querySelector(`.rudi-app-inject`);
        handleClickOpen(cardNode, injectNode, event, username, bearerToken, userResponse.odDeskPreferences, idString, userResponse.odSapidOE);
    });
}
function handleClickOpen(cardNode, injectNode, event, username, bearerToken, userPreferences, idString, sapidoe) {
    if (!injectNode) {
        injectNode = document.getElementById(idString);
    }
    else {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
    }
    if (cardNode.classList.contains("app-open")) {
        if (DEBUG)
            console.log("RespApp do nothing");
    }
    else {
        cardNode.classList.add('app-open');
        cardNode.classList.add('rudi-col-span-3');
        cardNode.classList.remove('rudi-max-height');
        const formNode = DomHelper.appendNode(injectNode, 'section', [], [], '', 'rudi-invitation-form');
        const listNode = DomHelper.appendNode(injectNode, 'section', [], [], '', 'rudi-invitation-list');
        renderInvitationForm(formNode, username, sapidoe, bearerToken);
        getBackendData("", `/users/invitation/list/${sapidoe}`, "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            DomHelper.appendSpinner(listNode);
            renderInvitationList(listNode, username, sapidoe, bearerToken, responseData);
        });
    }
}
function validateInvitationInput(valuetype, value, bearerToken) {
    if ((valuetype != 'mobile' && valuetype != 'mail'))
        throw 'Einladungstyp muss ausgewählt werden';
    if (!value)
        throw 'Bitte geben Sie einen Wert ein';
    if (valuetype == 'mobile') {
        const pattern = /^\+[0-9]+$/;
        if (!pattern.test(value))
            throw "Die Telefonnummer muss im Format +491123604... ohne Leerzeichen und Trennzeichen eingeben werden";
    }
    else if (valuetype == 'mail') {
        if (value.includes('rummelsberger'))
            throw "Alle Rummelsberger Mitarbeitenden haben bereits einen Account. Eine Einladung an Adressen der Rummelsberger Diakonie ist nicht möglich";
    }
}
function renderInvitationForm(parentNode, username, sapidoe, bearerToken) {
    DomHelper.appendNode(parentNode, 'h3', [], [], 'Neue Einladung versenden');
    DomHelper.appendNode(parentNode, 'p', [], [], 'Bitte geben Sie entweder eine E-Mail-Adresse oder eine Mobilfunknummer ein. Durch den Button einladen wird dann sofort der Einladungstext verschickt.');
    const formSection = DomHelper.appendNode(parentNode, 'section', ['rudi-form-input-group', 'rudi-form-inline'], []);
    const selectNode = DomHelper.appendNode(formSection, "select", ['rudi-inline-icon', 'form-select'], [
        { attr: "id", value: 'rudi-invitation-form-type' },
        { attr: "name", value: 'type' },
        { attr: "type", value: 'text' },
    ]);
    const values = [
        { label: "Mobil", value: "mobile" },
        { label: "E-Mail", value: "mail" }
    ];
    const valueSelected = 'mobile';
    if (values.length <= 1)
        selectNode.disabled = true;
    for (const option of values) {
        const optionNode = DomHelper.appendNode(selectNode, "option", ['form-select'], [{ attr: "value", value: option.value }], option.label);
        optionNode.selected = valueSelected == option.value;
    }
    const inputNode = DomHelper.appendInputText(parentNode, 'rudi-invitation-form', ['rudi-inline-icon'], [], 'username', '', '', [], false, formSection, true);
    const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
    DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
    btnNode.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (DEBUG)
            console.log('invitation clicked');
        let usernameIMP = inputNode.value;
        try {
            validateInvitationInput(selectNode.value, inputNode.value, bearerToken);
            getBackendData("", `/public/exists?type=${selectNode.value}&value=${Util.urlEncode(inputNode.value)}`, "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                console.log("exists?", responseData);
                let data = {
                    createdby: username,
                    sapidoe: sapidoe,
                    phone: "",
                    mail: ""
                };
                if (!responseData.exists) {
                    if (responseData.type == 'mobile') {
                        data.phone = responseData.value;
                    }
                    else {
                        data.mail = responseData.value;
                    }
                }
                else {
                }
                sendBackendData("", `/users/invitation`, "POST", "application/json", bearerToken, data, function (response) {
                    const responseData = JSON.parse(response.target.response);
                    console.log("createdInvitation?", responseData);
                });
            });
        }
        catch (e) {
            console.log(e);
        }
    });
}
function renderInvitationList(parentNode, username, sapidoe, bearerToken, data) {
    DomHelper.removeSpinner(parentNode);
    DomHelper.appendNode(parentNode, 'h3', [], [], 'Liste der Einladungen');
    if (data.length > 0) {
        const invitationHeaderRow = DomHelper.appendNode(parentNode, 'div', ['rudi-invitation-header'], [], '', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Eingeladen durch', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Mailadresse', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Telefonnummer', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Eingeladen am', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Status', '');
    }
    data.forEach(invitation => {
        const invitationNode = DomHelper.appendNode(parentNode, 'div', ['rudi-invitation-item'], [], '', '');
        const domIdUsername = Util.generateRandomDomId();
        DomHelper.appendNode(invitationNode, 'p', [], [], '', domIdUsername);
        Util.userId2DisplayName(store, invitation.createdby, domIdUsername, username, bearerToken);
        DomHelper.appendNode(invitationNode, 'p', [], [], invitation.mail, '');
        DomHelper.appendNode(invitationNode, 'p', [], [], invitation.phone, '');
        DomHelper.appendNode(invitationNode, 'p', [], [], Util.isoString2DateString(invitation.von), '');
        DomHelper.appendNode(invitationNode, 'p', [], [], invitation.completed ? 'Eingeladen' : 'Ausstehend', '');
    });
}
